import styled, { keyframes } from "styled-components";

export const RingSpinner = ({ color, size, sizeUnit }) => (
  <Container>
    <Spinner color={color} size={size} sizeUnit={sizeUnit} />
  </Container>
);

RingSpinner.defaultProps = {
  size: 50,
  color: "#00bfff",
  sizeUnit: "px",
};

const motion = (props) => keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 100%;
  height: 100%;
`;

const Spinner = styled.div`
  box-sizing: border-box;
  display: block;
  width: ${(p) => `${p.size}${p.sizeUnit}`};
  height: ${(p) => `${p.size}${p.sizeUnit}`};
  border: 6px solid ${(p) => p.color};
  border-radius: 50%;
  animation: ${(p) => motion(p)} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: ${(p) => p.color} transparent transparent transparent;
  margin-bottom: 10vh;

  :nth-child(1) {
    animation-delay: -0.45s;
  }
  :nth-child(2) {
    animation-delay: -0.3s;
  }
  :nth-child(3) {
    animation-delay: -0.15s;
  }
`;
